import Router from 'next/router'
import { PickByValueExact } from 'utility-types'
import { filterByType } from '../array'
import { filterFalsy } from '../object'
import { isClient, isString } from '../typeguard'
import * as ClientPaths from './clientPaths'

const INTERNAL_ROUTES = filterByType(Object.values(ClientPaths), isString)

const ID_PLACE_HOLDER = '-9999'
const ID_PATTERN = '[a-zA-Z0-9-]+'
const NO_SLASH = '(?!.*/)'
const QUERY_PATTERN = '(\\?|\\?.+&)'

const idPaths: PickByValueExact<
  typeof ClientPaths,
  (id: number | string) => string
> = {
  greet: ClientPaths.greet,
  contributionDetail: ClientPaths.contributionDetail,
  editContribution: ClientPaths.editContribution,
}

const idPathsToPatterns = (args: ((id: number) => string)[]) =>
  args.map(
    (arg) =>
      arg(+ID_PLACE_HOLDER)
        .replace(ID_PLACE_HOLDER, ID_PATTERN)
        .replace('?', QUERY_PATTERN) + NO_SLASH,
  )
const INTERNAL_ROUTES_PATTERN = new RegExp(
  `(?:${[...idPathsToPatterns(Object.values(idPaths))].join('|')})`,
)

export const isClientPath = (path: string) =>
  INTERNAL_ROUTES.includes(extractPathname(path)) ||
  INTERNAL_ROUTES_PATTERN.test(path)

export const extractPathname = (path: string = '') => path.split(/[?#]/)[0]

export const query = (
  path: string,
  queryParam: any = {},
): Parameters<typeof Router['push']>[0] => {
  const filteredParam = filterFalsy(queryParam)
  if (!Object.keys(filteredParam).length) return path
  return { query: filteredParam }
}
export const shouldNoIndex = (path: string) =>
  path.startsWith(ClientPaths.MYPAGE)

export const previousPath = () => {
  if (!isClient()) return ''
  try {
    const url = new URL(document.referrer)
    console.log(url)
    return url.pathname
  } catch {
    console.log(document.referrer)
    return ''
  }
}
